import { FunctionComponent, memo } from "react";
import { IProps } from "./tag-group-header.types";
import { AccordionItemHeader } from "@edgetier/client-components";
import TagGroupActionsMenu from "./tag-group-actions-menu";
import "./tag-group-header.scss";

/**
 * A header for each tag group.
 * @param props.tagGroup   The name of the tag group being displayed.
 * @param props.tagGroupId The ID of the tag group being displayed.
 */
const TagGroupHeader: FunctionComponent<IProps> = ({ tagCount, tagGroup, tagGroupId }) => (
    <AccordionItemHeader>
        <div className="tag-group-header">
            <h3>{tagGroup}</h3>
            <span className="tag-group-header__tag-count">{`${tagCount} tags`}</span>
            <TagGroupActionsMenu tagGroup={tagGroup} tagGroupId={tagGroupId} />
        </div>
    </AccordionItemHeader>
);

export default memo(TagGroupHeader);
